import { Component, OnInit } from '@angular/core';
import { SessionManagementService } from '../session-management-service/session-management.service';
import { EnvironmentService } from '../environment-service/environment.service';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { serviceBusMetric } from './service-bus-metric';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-service-bus-metrics',
  templateUrl: './service-bus-metrics.component.html',
  styleUrls: ['./service-bus-metrics.component.scss']
})
export class ServiceBusMetricsComponent implements OnInit {

  data: serviceBusMetric[];
  filteredData: serviceBusMetric[];

  sortColumnName: string = 'DeadLetterMessageCount';
  sortOrderAscending: boolean = true;
  sortIsNumeric: boolean = true;
  removeZeroes: boolean = false;

  private sub: any;

  constructor(private sessionManagementService: SessionManagementService,
    private environmentService: EnvironmentService,
    private http: HttpClient, private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      this.removeZeroes = params['removeZeroes'] == 'true';
    });

    console.log("Loading queue data.");
    var url = this.environmentService.getApiRoot() + "subscriptionmetrics";

    // let headers = new Headers();
    // headers.append('telemetry-session', this.sessionManagementService.getSession());
    // headers.append('telemetry-request', this.sessionManagementService.uuidFast());
    // let options = new RequestOptions({ headers: headers });

    this.http.get(url).subscribe(
      (resp: any) => {
        this.data = resp as serviceBusMetric[]; // JSON.parse(resp.text());
        this.updateFiltering();
        this.sortNumericClick(this.sortColumnName);
      }
    );
  }

  private updateFiltering() {
    if (this.removeZeroes) {
      this.filteredData = this.data.filter(m => m.ActiveMessageCount != "0" || m.DeadLetterMessageCount != "0");
    }
    else {
      this.filteredData = this.data;
    }
    this.sort();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onRemoveZeroesClicked() {
    this.removeZeroes = !this.removeZeroes;
    this.router.navigate(["serviceBusMetrics", { removeZeroes: this.removeZeroes }]);

    this.updateFiltering();
  }

  sort() {
    if (this.sortIsNumeric) {
      this.sortNumeric(this.sortColumnName);
    }
    else {
      this.sortLex(this.sortColumnName);
    }
  }


  sortLexClick(columnName: string) {
    this.sortIsNumeric = false;
    this.resetSort(columnName);
    this.sortLex(columnName);
  }

  sortLex(columnName: string) {
    this.filteredData = this.filteredData.sort((v1, v2) => {
      if (v1[this.sortColumnName].toLowerCase() > v2[this.sortColumnName].toLowerCase()) {
        return this.sortOrderAscending ? 1 : -1;
      }
      if (v1[this.sortColumnName].toLowerCase() < v2[this.sortColumnName].toLowerCase()) {
        return this.sortOrderAscending ? -1 : 1;
      }
      return 0;
    });
  }

  sortNumericClick(columnName: string) {
    this.sortIsNumeric = true;
    this.resetSort(columnName);
    this.sortNumeric(columnName);
  }

  sortNumeric(columnName: string) {
    this.filteredData = this.filteredData.sort((v1, v2) => {
      var diff = v1[this.sortColumnName] - v2[this.sortColumnName];
      if (this.sortOrderAscending)
        return diff;
      else
        return -diff;
    });
  }

  resetSort(columnName) {
    if (columnName == this.sortColumnName) {
      this.sortOrderAscending = !this.sortOrderAscending;
    }
    else {
      this.sortColumnName = columnName;
      this.sortOrderAscending = true;
    }
  }

}
